module.exports = __webpack_public_path__ + "img/c05_unitbatteringram_Normal_ua.a5fb2f8f.webp";